import React from 'react';
import {IBaseAppModel} from './model/appModel';
import config from './service/config';
import './static/css/index-embed.less';
import StateProvider from './context/stateProvider';
import {BrowserRouter} from 'react-router-dom';
import WhatsNew from './component/whatsNew/WhatsNew';
import {DndProvider} from 'react-dnd';
import {HTML5Backend} from 'react-dnd-html5-backend';
import {createRoot} from 'react-dom/client';

export default (model: IBaseAppModel) => {
   const whatsNewRoot = document.getElementById('whats-new-root');

   document.body.classList.add('app-body');

   config.initWhatsNew(model);

   createRoot(whatsNewRoot).render(
      <DndProvider backend={HTML5Backend}>
         <BrowserRouter>
            <StateProvider>
               <WhatsNew />
            </StateProvider>
         </BrowserRouter>
      </DndProvider>
   );
};